import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as homeReducer from "containers/Home/reducer";
import * as galleryReducer from "containers/Gallery/GalleryReducer";
import * as loginReducer from "containers/Login/reducer";

import { GALLERY_RIGHT_MODE } from "containers/Gallery/GalleryReducer";

import Feedback from "components/Gallery/Feedback";

class FeedbackContainer extends React.PureComponent {
  render() {
    const {} = this.props;

    return <Feedback {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    openPanel: () => dispatch(galleryReducer.updateRightMode(ownProps.id, GALLERY_RIGHT_MODE.FEEDBACK)),
    toggleDatasetRating: (rating) => dispatch(homeReducer.toggleRating(ownProps.id, rating)),
    postComment: (comment) => dispatch(homeReducer.postComment(ownProps.id, comment)),
    deleteComment: (commentId) => dispatch(homeReducer.deleteComment(ownProps.id, commentId)),
    addTag: (tagName) => dispatch(homeReducer.postTag(ownProps.id, tagName)),
    deleteTag: (tagName) => dispatch(homeReducer.deleteTag(ownProps.id, tagName)),
    fetchFeedback: () => dispatch(homeReducer.fetchDatasetFeedback(ownProps.id, undefined))
  };
};
const mapStateToProps = (state, ownProps) => {
  return {
    tags: homeReducer.getTags(state, ownProps.id),
    userId: loginReducer.getUserID(state),
    commentCount: homeReducer.getCommentCount(state, ownProps.id),
    comments: homeReducer.getComments(state, ownProps.id),
    positiveRatingCount: homeReducer.getPositiveRatingCount(state, ownProps.id),
    negativeRatingCount: homeReducer.getNegativeRatingCount(state, ownProps.id),
    negativeRatings: homeReducer.getNegativeRatings(state, ownProps.id),
    positiveRatings: homeReducer.getPositiveRatings(state, ownProps.id),
    userRating: homeReducer.getUserRating(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(FeedbackContainer);
